import { useTranslation } from "react-i18next";
import image from "../../common/images/3.jpg";

const AboutSection = () => {
  const { t } = useTranslation(["common"]);

  return (
    <main className="bg-gray-50 text-gray-800" id="about">
      <div className="container mx-auto px-3 min-h-screen flex items-center justify-center">
        <section className="relative pt-12">
          <div className="flex items-center flex-wrap">
            <div className="w-full h-full md:w-4/12  ml-auto mr-auto">
              <img
                src={image}
                alt="..."
                className="w-full h-full md:min-h-[600px] object-cover rounded-lg shadow-xl shadow-red-200"
              />
            </div>
            <div className="w-full md:w-5/12 ml-auto mr-auto">
              <div className="">
                <h1 className="text-4xl font-semibold text-gray-800 md:text-4xl text-center mt-10 md:mt-0">
                  Sada <span className="text-yellow-600">suw</span>
                </h1>

                <p className="mt-4 text-lg leading-relaxed text-blueGray-500"></p>
                <ul className="list-none mt-6">
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <h1 className="text-lg">
                          {t("common:about_text_paragraph_1")}
                        </h1>
                      </div>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <h1 className="text-lg">
                          {t("common:about_text_paragraph_2")}
                        </h1>
                      </div>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <h1 className="text-lg">
                          {t("common:about_text_paragraph_3")}
                        </h1>
                      </div>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <h1 className="text-lg">{t("common:products_text")}</h1>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default AboutSection;
